/*
Copyright 2025 Adobe. All rights reserved.
This file is licensed to you under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License. You may obtain a copy
of the License at http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software distributed under
the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
OF ANY KIND, either express or implied. See the License for the specific language
governing permissions and limitations under the License.
*/

import { tag as html, TemplateResult } from '../custom-tag.js';

export { setCustomTemplateLiteralTag } from '../custom-tag.js';
export const ViewedMarkAsIcon = ({
  width = 24,
  height = 24,
  hidden = false,
  title = 'Viewed Mark As',
} = {}): string | TemplateResult => {
  return html`<svg
    xmlns="http://www.w3.org/2000/svg"
    height="${height}"
    viewBox="0 0 36 36"
    width="${width}"
    aria-hidden=${hidden ? 'true' : 'false'}
    role="img"
    fill="currentColor"
    aria-label="${title}"
  >
    <path
      d="M22.794 15.554A5 5 0 0 0 23.063 14a4.691 4.691 0 0 0-.175-1.2 2.623 2.623 0 0 1-2.221 1.279A2.667 2.667 0 0 1 18 11.417a2.631 2.631 0 0 1 1.35-2.269 4.916 4.916 0 0 0-1.35-.21 5.052 5.052 0 0 0-.272 10.1 12.3 12.3 0 0 1 5.066-3.484Z"
    />
    <path
      d="M15.477 22.831A9.207 9.207 0 1 1 27.225 14c0 .276-.057.537-.081.807a12.227 12.227 0 0 1 5.894 1.583 4.365 4.365 0 0 0 .712-2.03c0-2.364-4.214-7.341-9.137-9.78A14.978 14.978 0 0 0 18 2.937c-8.664 0-15.75 8.625-15.75 11.424 0 2.626 5.729 8.868 12.683 10.372a12.177 12.177 0 0 1 .544-1.902Z"
    />
    <path
      d="M27 18.1a8.9 8.9 0 1 0 8.9 8.9 8.9 8.9 0 0 0-8.9-8.9Zm-2.338 14.312-4.128-4.128a.5.5 0 0 1 0-.707l1.036-1.036a.5.5 0 0 1 .707 0l2.731 2.731 6.106-6.106a.5.5 0 0 1 .707 0l1.043 1.043a.5.5 0 0 1 0 .707l-7.5 7.5a.5.5 0 0 1-.702-.004Z"
    />
  </svg>`;
};
